import script from "./percentage-complete-block.vue?vue&type=script&setup=true&lang=js"
export * from "./percentage-complete-block.vue?vue&type=script&setup=true&lang=js"

import "./percentage-complete-block.vue?vue&type=style&index=0&id=74468bc5&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74468bc5"]])

export default __exports__